import config from '../../config/config';
import { RequestInvoiceInterface } from '../../interface/invoice-interface';

import getRequest from './base/get';

export default {
  /**
   * Fetch invoice list
   * @param {RequestInvoiceInterface} query - The query parameters
   * @returns {Promise<any>} A promise resolving to the invoice list
   */
  fetchInvoiceList: (query: RequestInvoiceInterface = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.emsp.invoiceApiUrl}api/emsp/v1/invoices`, {
      ...parameters,
    });
  },

  /**
   * Fetch invoice details by ID.
   * @param {string} id - The invoice identifier.
   * @returns {Promise<any>} A promise resolving to the invoice details.
   */
  fetchInvoiceById: (id: string): Promise<any> => {
    return getRequest(`${config.emsp.invoiceApiUrl}api/emsp/v1/invoices/${encodeURIComponent(id)}`);
  },

  /**
   * Fetch invoice filters
   * @returns {Promise<any>} A promise resolving to the invoice filters
   */
  fetchInvoiceFilters: (): Promise<any> => {
    return getRequest(`${config.emsp.invoiceApiUrl}api/emsp/v1/invoices/list-filters`);
  },

  /**
   * Export invoices
   * @param {any} [query] - The query parameters
   * @returns {Promise<any>} A promise resolving to the exported data
   */
  invoiceExport: (query: any = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.emsp.invoiceApiUrl}api/emsp/v1/invoices/export-data`, {
      ...parameters,
    });
  },
};
